var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-section"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.categoryName))]),_c('div',{staticClass:"fields"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }